import { render, staticRenderFns } from "./FintechSearch.vue?vue&type=template&id=37466ee0&"
import script from "./FintechSearch.vue?vue&type=script&lang=js&"
export * from "./FintechSearch.vue?vue&type=script&lang=js&"
import style0 from "./FintechSearch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports